import { preloadImages } from "@/assets/js/common.js";

const list = [
  "/horizontal-icon.png",
  "/page-bottom.png",
  "/header-close.png",
  "/header-icon.png",
  "/header-menu-1.png",
  "/header-menu-2.png",
  "/header-menu-3.png",
  "/header-menu-4.png",
  "/header-menu-5.png",
  "/header-menu-bg.png",
  "/header-menu-icon.png",
  "/header-menu-line.png",
];

const loadingPageList = [
  "/loading-bg.png",
  "/loading-logo-1.png",
  "/loading-logo-2.png",
];

const homePageList = [
  "/home-bg.png",
  "/home-circle.png",
  "/home-game.png",
  "/home-gift.png",
  "/home-keyboard.png",
  "/home-light-1.png",
  "/home-light-2.png",
  "/home-light-3.png",
  "/home-light-4.png",
  "/home-logo.png",
  "/home-slogan.png",
  "/home-video.png",
  "/home-yaogan.png",
];
const introPageList = [
  "/intro-bg.png",
  "/intro-btn-comment.png",
  "/intro-btn-dy.png",
  "/intro-btn-gift.png",
  "/intro-btn-home.png",
  "/intro-btn-qiandao.png",
  "/intro-btn-tap.png",
  "/intro-btn-wx.png",
  "/intro-code-jlsy.jpg",
  "/intro-code-lnwan.jpg",
  "/intro-code-shdl.jpg",
  "/intro-code-shyyl.jpg",
  "/intro-code-xlwy.jpg",
  "/intro-pic-1-back.png",
  "/intro-pic-1-front.png",
  "/intro-pic-2-back.png",
  "/intro-pic-2-front.png",
  "/intro-pic-3-back.png",
  "/intro-pic-3-front.png",
  "/intro-pic-4-back.png",
  "/intro-pic-4-front.png",
  "/intro-pic-5-back.png",
  "/intro-pic-5-front.png",
  "/intro-swiper-1.png",
  "/intro-swiper-2.png",
  "/intro-text.png",
  "/intro-video.png",
  "/code-bg-left.png",
  "/code-bg.png",
  "/code-lnw.jpg",
];

const gamePageList = [
  "/game-bottom.png",
  "/game-download.png",
  "/game-htfsl.png",
  "/game-jlsy.png",
  "/game-kefu.png",
  "/game-shdl.png",
  "/game-shyyl.png",
  "/game-text.png",
  "/game-xlwy.png",
];

const aboutPageList = [
  "/about-bg.png",
  "/about/about-block-left.png",
  "/about/about-block-right.png",
  "/about/about-pagination-1.png",
  "/about/about-pagination-2.png",
  "/about/about-pagination-3.png",
  "/about/about-pagination-check-1.png",
  "/about/about-pagination-check-2.png",
  "/about/about-pagination-check-3.png",
  "/about/about-pagination-line.png",
  "/about/brief-ball.png",
  "/about/brief-text-bg.png",
  "/about/brief-slogan.png",
  "/about/brief-star.png",
  "/about/brief-text.png",
  "/about/history-2015-img.png",
  "/about/history-2015-timeline.png",
  "/about/history-2016-img.png",
  "/about/history-2016-timeline.png",
  "/about/history-2017-img.png",
  "/about/history-2017-timeline.png",
  "/about/history-2018-img.png",
  "/about/history-2018-timeline.png",
  "/about/history-2019-img.png",
  "/about/history-2019-timeline.png",
  "/about/history-2020-img.png",
  "/about/history-2020-timeline.png",
  "/about/history-2021-img.png",
  "/about/history-2021-timeline.png",
  "/about/history-2022-img.png",
  "/about/history-2022-timeline.png",
  "/about/history-2023-img.png",
  "/about/history-2023-timeline.png",
  "/about/history-2024-img.png",
  "/about/history-2024-timeline.png",
  "/about/history-circle.png",
  "/about/history-text.png",
  "/about/history-timeline-image-1.png",
  "/about/history-timeline.png",
  "/about/impression-1.png",
  "/about/impression-2.png",
  "/about/impression-3.png",
  "/about/impression-4.png",
  "/about/impression-5.png",
  "/about/impression-6.png",
  "/about/impression-7.png",
  "/about/impression-8.png",
  "/about/impression-9.png",
  "/about/impression-block-1.png",
  "/about/impression-block-2.png",
  "/about/impression-block-3.png",
  "/about/impression-saucer.png",
  "/about/impression-text.png",
  "/about/left-arrow.png",
  "/about/right-arrow.png",
];

const workPageList = [
  "/work-1.png",
  "/work-2.png",
  "/work-3.png",
  "/work-bg.png",
  "/work-btn-1.png",
  "/work-btn-2.png",
  "/work-middle-text.png",
  "/work-text.png",
];
export function loadLoadingPage() {
  preloadImages(loadingPageList.map((v) => require("@/assets/images" + v)));
}
export function loadHomePage() {
  preloadImages(homePageList.map((v) => require("@/assets/images" + v)));
}
export function loadIntroPage() {
  preloadImages(introPageList.map((v) => require("@/assets/images" + v)));
}
export function loadGamePage() {
  preloadImages(gamePageList.map((v) => require("@/assets/images" + v)));
}
export function loadAboutPage() {
  preloadImages(aboutPageList.map((v) => require("@/assets/images" + v)));
}
export function loadWorkPage() {
  preloadImages(workPageList.map((v) => require("@/assets/images" + v)));
}
export function loadOtherPage() {
  preloadImages(list.map((v) => require("@/assets/images" + v)));
}
